export const requests = [
  {
    short: 'Convenzione ONU',
    title: 'Attuare la Convenzione',
    text: 'L’implementazione della Convenzione ONU sui diritti delle persone con disabilità, attraverso l’attuazione delle norme di legge vigenti in materia e la predisposizione dei provvedimenti legislativi ancora mancanti.',
  },
  {
    short: 'Partecipazione',
    title: 'Nulla su di noi senza di noi',
    text: 'Il coinvolgimento delle persone con disabilità nelle decisioni che le riguardano, applicando concretamente lo slogan della Convenzione “Nulla su di noi senza di noi”.',
  },
  {
    short: 'Progetti di vita',
    title: 'Costruire insieme i progetti di vita',
    text: 'La stabile e continua collaborazione tra i servizi, le famiglie e le associazioni e cooperative di volontariato, nella realizzazione dei progetti di vita della persona con disabilità e del suo accompagnamento alla vita adulta.',
  },
  {
    short: 'Commissione ONU',
    title: 'Rafforzare la Commissione',
    text: 'Il rafforzamento e il consolidamento del ruolo della Commissione sammarinese per l’attuazione della Convenzione ONU sui diritti delle persone con disabilità, attribuendole maggiori poteri e più risorse.',
  },
  {
    short: 'Scuola e lavoro',
    title: 'Dalla scuola al lavoro',
    text: 'Il celere avvio di un tavolo di confronto per individuare le soluzioni alle problematiche urgenti dei soggetti con disabilità in età post scolare e per colmare le carenze ancora latenti nell’inclusione scolastica e nell’inclusione lavorativa.',
  },
  {
    short: 'Non autosufficienza',
    title: 'Un Piano per la non autosufficienza',
    text: 'L’istituzione di un Piano per la non autosufficienza che includa i modelli prestazionali di assistenza sociale di cui c’è urgenza — Caregiver e Assistente Personale — e apposite normative su “Vita Indipendente” e sul cosiddetto “Dopo di Noi”, al fine di garantire libertà e dignità alle persone con disabilità e serenità alle loro famiglie.',
  },
  {
    short: 'Punto unico',
    title: 'Un luogo per pratiche e informazioni',
    text: 'La creazione di un “luogo” finalizzato a istruire tutte le pratiche e a fornire tutte le informazioni di cui necessitano le persone con disabilità e le loro famiglie, così come previsto dall’articolo 10 del Decreto Delegato 1 febbraio 2018 n. 14.',
  },
  {
    short: 'Ausili e protesi',
    title: 'Aggiornare il Prontuario Nomenclatore',
    text: 'L’aggiornamento e la pubblicazione del Prontuario Nomenclatore che tenga conto delle esigenze di tutte le persone con disabilità — comprese le più gravi — e del rapido progresso tecnologico che rende talvolta superati in breve tempo ausili e protesi, così come previsto dall’articolo 7, comma 3b, del Decreto Delegato 1 febbraio 2018 n. 14.',
  },
  {
    short: 'Rimozione barriere',
    title: 'Rimuovere tutte le barriere',
    text: 'La rimozione degli ostacoli che impediscono la piena partecipazione delle persone con disabilità alla vita sociale e politica, a partire dalla rimozione delle barriere architettoniche, comunicative, digitali e burocratiche.',
  },
  {
    short: 'Non discriminazione',
    title: 'Rispettare ogni differenza',
    text: 'Il rispetto dell’eterogeneità personale e culturale di tutti i soggetti con disabilità, senza eccezioni e senza discriminazioni.',
  },
  {
    short: 'Dati e inclusione',
    title: 'Conoscere per includere',
    text: 'L’avvio di uno studio statistico che vada oltre l’aspetto sanitario e sia in grado di fornire i dati fondamentali per comprendere e valutare il reale livello di partecipazione e di inclusione delle persone con disabilità.',
  },
  {
    short: 'Risorse ed equità',
    title: 'Riconsiderare le risorse in modo equo',
    text: 'Lo studio approfondito, in termini di quantità e qualità, delle risorse economiche e umane messe a disposizione dallo Stato per la disabilità e la loro riconsiderazione in modo equo.',
  },
]

export const documents = [
  { label: 'Documento consegnato alla Reggenza', type: 'PDF', href: '/documenti/documento-arengo-12-richieste.pdf' },
  { label: 'Discorso di Attiva-Mente', type: 'DOCX', href: '/documenti/discorso-attiva-mente.docx' },
  { label: 'Saluto del Vescovo Andrea Turazzi', type: 'PDF', href: '/documenti/saluto-vescovo-andrea-turazzi.pdf' },
  { label: 'Comunicato stampa', type: 'PDF', href: '/documenti/comunicato-stampa.pdf' },
]

export const pressClippings = [
  {
    source: 'Corriere Romagna',
    date: '22 febbraio 2021',
    title: 'Disabili, famiglie in piazza: «Basta con le discriminazioni»',
    src: '/rassegna-stampa/corriere-romagna-22-febbraio-2021.jpg',
    alt: 'Articolo del Corriere Romagna sull’Arengo delle famiglie davanti alla Basilica del Santo',
    width: 1007,
    height: 1180,
  },
  {
    source: 'Rassegna stampa',
    date: 'Febbraio 2021',
    title: 'Inclusione e assistenza, le richieste ai Reggenti',
    src: '/rassegna-stampa/inclusione-assistenza-richieste-reggenti.jpg',
    alt: 'Articolo sulle richieste di inclusione e assistenza presentate ai Capitani Reggenti',
    width: 1040,
    height: 651,
  },
  {
    source: 'La Serenissima',
    date: '23 febbraio 2021',
    title: 'CSdL: «Sia garantito il diritto al lavoro alle persone con disabilità»',
    src: '/rassegna-stampa/la-serenissima-23-febbraio-2021.jpg',
    alt: 'Pagina de La Serenissima sul diritto al lavoro delle persone con disabilità',
    width: 1105,
    height: 916,
  },
  {
    source: 'Repubblica.sm',
    date: '23 febbraio 2021',
    title: 'Una pagina che rimarrà nella storia di San Marino',
    src: '/rassegna-stampa/repubblica-sm-23-febbraio-2021.jpg',
    alt: 'Pagina di Repubblica.sm dedicata alla giornata dell’Arengo delle famiglie',
    width: 991,
    height: 999,
  },
  {
    source: 'L’Informazione di San Marino',
    date: '23 febbraio 2021',
    title: 'Arengo delle famiglie, «pagina storica»',
    src: '/rassegna-stampa/linformazione-copertina-23-febbraio-2021.jpg',
    alt: 'Prima pagina de L’Informazione di San Marino con il richiamo all’Arengo delle famiglie',
    width: 949,
    height: 1356,
  },
  {
    source: 'L’Informazione di San Marino',
    date: '23 febbraio 2021 · pagine 8–9',
    title: 'Arengo delle famiglie, una pagina che rimarrà nella storia',
    src: '/rassegna-stampa/linformazione-pagine-8-9-23-febbraio-2021.jpg',
    alt: 'Doppia pagina de L’Informazione dedicata all’Arengo e alle dodici richieste',
    width: 1920,
    height: 1340,
  },
  {
    source: 'L’Informazione di San Marino',
    date: '23 febbraio 2021 · pagina 10',
    title: 'Il messaggio alla Reggenza dell’Arengo delle famiglie',
    src: '/rassegna-stampa/linformazione-pagina-10-23-febbraio-2021.jpg',
    alt: 'Pagina de L’Informazione con il documento consegnato alla Reggenza',
    width: 956,
    height: 1354,
  },
  {
    source: 'Archivio Attiva-Mente',
    date: 'Verso l’Arengo 2021',
    title: 'Attiva-Mente promuove l’Arengo delle famiglie di persone con disabilità',
    src: '/rassegna-stampa/attiva-mente-promuove-arengo.png',
    alt: 'Articolo di presentazione dell’Arengo con l’elenco dei dodici punti prioritari',
    width: 924,
    height: 864,
  },
]

export const photoEssay = [
  {
    title: 'Essere presenti',
    date: '21 febbraio 2021',
    src: '/assets/fotografie/essere-presenti-2021.webp',
    alt: 'Partecipanti all’Arengo con le mascherine, tra loro una persona in sedia a rotelle, riuniti nel Piazzale Domus Plebis',
    width: 2200,
    height: 1469,
  },
  {
    title: 'La musica accompagna le voci',
    date: '21 febbraio 2021',
    src: '/assets/fotografie/akiko-yatani-violino-2021.webp',
    alt: 'La violinista Akiko Yatani durante l’accompagnamento musicale dell’Arengo, con una mascherina decorata con lo stemma di San Marino',
    width: 2200,
    height: 1469,
  },
  {
    title: 'La comunità davanti alla Basilica',
    date: '21 febbraio 2021',
    src: '/assets/fotografie/arengo-striscione-basilica-2021.webp',
    alt: 'La comunità riunita davanti alla Basilica del Santo e il lungo striscione contro l’indifferenza',
    width: 2200,
    height: 1469,
  },
  {
    title: 'Il Piazzale Domus Plebis',
    date: '21 febbraio 2021',
    src: '/assets/fotografie/comunita-piazza-2021.webp',
    alt: 'Veduta dall’alto delle persone distanziate nel Piazzale Domus Plebis durante l’Arengo',
    width: 2200,
    height: 1469,
  },
  {
    title: 'Un messaggio contro l’indifferenza',
    date: '21 febbraio 2021',
    src: '/assets/fotografie/striscione-indifferenza-2021.webp',
    alt: 'Lo striscione con la frase L’indifferenza è l’essenza della disumanità davanti alla Basilica del Santo',
    width: 2200,
    height: 1469,
  },
  {
    title: 'La firma',
    date: '21 febbraio 2021',
    src: '/assets/fotografie/firma-arengo-2021.webp',
    alt: 'Il momento della firma del messaggio dell’Arengo all’ingresso della Basilica del Santo',
    width: 2200,
    height: 1469,
  },
  {
    title: 'La stele e la bandiera',
    date: '21 febbraio 2021',
    src: '/assets/fotografie/stele-bandiera-2021.webp',
    alt: 'La stele commemorativa dell’Arengo accanto alla bandiera della Repubblica di San Marino',
    width: 2200,
    height: 3296,
  },
]

export const sourceLinks = {
  project: 'https://www.attiva-mente.info/arengo-delle-famiglie-di-persone-con-disabilit%C3%A0',
  article: 'https://www.attiva-mente.info/news/una-richiesta-accolta-un-simbolo-finalmente-illuminato',
  video: 'https://archive.org/download/arengo-delle-famiglie-di-persone-con-disabilita/Arengo%20delle%20famiglie%20di%20persone%20con%20disabilit%C3%A0.mp4',
  archive: 'https://archive.org/details/arengo-delle-famiglie-di-persone-con-disabilita',
  official: 'https://www.attiva-mente.info/',
}
